import { render, staticRenderFns } from "./hasFireplaceLessThanTenYears.vue?vue&type=template&id=8ffb4cf8&scoped=true"
import script from "./hasFireplaceLessThanTenYears.vue?vue&type=script&lang=ts"
export * from "./hasFireplaceLessThanTenYears.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffb4cf8",
  null
  
)

export default component.exports